<template>
  <CollapsiblePanel
    :title="resolvedTitle"
    :subtitle="resolvedSubtitle"
    :accent-color="resolvedAccentColor"
    :open="isOpenByDefault"
    data-collapsible-panel-v="1.0.1"
  >
    <template #title>
      <slot name="title" />
    </template>
    <template #subtitle>
      <slot name="subtitle" />
    </template>
    <template #default>
      <slot />
    </template>
  </CollapsiblePanel>
</template>

<script setup lang="ts">
import { useHost } from 'vue'
import CollapsiblePanel from '~/components/CollapsiblePanel.vue'

const props = defineProps<{
  title?: string
  subtitle?: string
  accentColor?: string
  open?: boolean | string
}>()

const host = useHost()

const resolvedTitle = computed(() => {
  return props.title || host?.getAttribute('title') || ''
})

const resolvedSubtitle = computed(() => {
  return props.subtitle || host?.getAttribute('subtitle') || ''
})

const resolvedAccentColor = computed(() => {
  return props.accentColor || host?.getAttribute('accent-color') || undefined
})

const isOpenByDefault = computed(() => {
  const rawOpen = props.open ?? host?.getAttribute('open')

  return (
    rawOpen === '' || rawOpen === true || rawOpen === 'true' || rawOpen === '1'
  )
})
</script>
